import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import AuthSliceReducer from "./_redux/AuthSlice";
import HighlightReducer from "./_redux/HighlightSlice";
import SelectedApplicantReducer from "./_redux/SelectedApplicantSlice";
import SelectedJobPostingReducer from "./_redux/SelectedJobPostingSlice";
import uiSliceReducer from "./_redux/Uislice";
import { LoaderSlice, UncommonLoaderSlice } from "./_redux/LoaderSlice";
import SeletedNextPathSliceReducer from "./_redux/SelectedNextPath";
import SeletedJobCodeReducer from "./_redux/SeletedJobCodeSlice";
import SeletedapplicantIdsReducer from "./_redux/SeletedapplicantIdsSlice";
import SessionConflictReducer from "./_redux/SessionConflictSlice";
import SnackbarSliceReducer from "./_redux/SnackbarSlice";
import UnsavedReducer from "./_redux/UnsavedSlice";
import themeReducer from "./_redux/_services/ThemeSlice";
import ReportDataSliceReducer from "./_redux/ReportDataSlice";
//service calls
import * as _applicantslice from "./_redux/_services/ApplicantsSlice";
import * as _billingslice from "./_redux/_services/BillingSlice";
import * as _clientslice from "./_redux/_services/ClientsSlice";
import * as _cloudslice from "./_redux/_services/CloudSourcingSlice";
import * as _postingslice from "./_redux/_services/JobPostingSlice";
import * as _Projectslice from "./_redux/_services/ProjectsSlice";
import * as _userslice from "./_redux/_services/UserManagerSlice";
import * as _customreportsslice from "./_redux/_services/CustomReportsSlice";

const appReducer = combineReducers({
  SeletedJobCode: SeletedJobCodeReducer,
  SeletedApplicantIds: SeletedapplicantIdsReducer,
  Loader: LoaderSlice.reducer,
  UncommonLoader: UncommonLoaderSlice.reducer,
  Snackbar: SnackbarSliceReducer,
  SessionConflict: SessionConflictReducer,
  Auth: AuthSliceReducer,
  SeletedNextPath: SeletedNextPathSliceReducer,
  Unsaved: UnsavedReducer,
  Highlight: HighlightReducer,
  SelectedApplicant: SelectedApplicantReducer,
  SelectedJobPosting: SelectedJobPostingReducer,
  ui: uiSliceReducer,
  ReportData: ReportDataSliceReducer,

  //posting service calls
  Jobparsing: _postingslice.jobparsingSlice.reducer,
  Addjobpostings: _postingslice.addjobpostingsSlice.reducer,
  Listjobpostings: _postingslice.listjobpostingsSlice.reducer,
  Deletejobpostings: _postingslice.deletejobpostingsSlice.reducer,
  Jobpostingsbyid: _postingslice.jobpostingsbyidSlice.reducer,
  GetCountries: _postingslice.getCountriesSlice.reducer,
  GetStatebyCountry: _postingslice.getStatebyCountrySlice.reducer,
  Editjobpostings: _postingslice.editjobpostingsSlice.reducer,
  Getdocuments: _postingslice.getdocumentsSlice.reducer,
  Deletedocuments: _postingslice.deletedocumentsSlice.reducer,
  DownloadFileFromS3: _postingslice.downloadFileFromS3Slice.reducer,
  UploadDocuments: _postingslice.uploadDocumentsSlice.reducer,
  GetAssociatedApplicants: _postingslice.getAssociatedApplicantsSlice.reducer,
  GetAssociatedApplicantById:
    _postingslice.getAssociatedApplicantByIdSlice.reducer,
  DeleteAssociatedJobseeker:
    _postingslice.deleteAssociatedJobseekerSlice.reducer,
  SearchAffinda: _postingslice.searchAffindaSlice.reducer,
  DeleteAssociatedJob: _postingslice.deleteAssociatedJobSlice.reducer,
  AddAssociatedjobs: _postingslice.addAssociatedjobsSlice.reducer,
  Getnotes: _postingslice.getnotesSlice.reducer,
  AddNotes: _postingslice.addNotesSlice.reducer,
  EditNotes: _postingslice.editNotesSlice.reducer,
  GetQuestionsList: _postingslice.getQuestionsListSlice.reducer,
  GetListofQuestions: _postingslice.getListofQuestionsSlice.reducer,
  RemoveQuestions: _postingslice.removeQuestionsSlice.reducer,
  UpdateQuestions: _postingslice.updateQuestionsSlice.reducer,
  AddQuestions: _postingslice.addQuestionsSlice.reducer,
  GetManagerTeamlead: _postingslice.getManagerTeamleadSlice.reducer,
  GetPostingsComments: _postingslice.getPostingsCommentsSlice.reducer,
  UpdateCandidateStatus: _postingslice.updateCandidateStatusSlice.reducer,
  GetListSegments: _postingslice.getListSegmentsSlice.reducer,
  GetListVendors: _postingslice.getListVendorsSlice.reducer,
  UpdatePortals: _postingslice.updatePortalsSlice.reducer,
  GetResumeswithMatchPercentage: _postingslice.GetResumeswithMatchPercentageSlice.reducer,
  UpdateAssociatedResume: _postingslice.updateAssociatedResumeSlice.reducer,

  //applicants service calls
  UploadResume: _applicantslice.uploadResumeSlice.reducer,
  SetPrimaryDocument: _applicantslice.setPrimaryDocumentSlice.reducer,
  DuplicateResume: _applicantslice.duplicateResumeSlice.reducer,
  AddApplicants: _applicantslice.addApplicantsSlice.reducer,
  ApplicantsById: _applicantslice.applicantsByIdSlice.reducer,
  EditApplicants: _applicantslice.editApplicantsSlice.reducer,
  AddExelBulkApplicants: _applicantslice.addExelBulkApplicantsSlice.reducer,
  GetApplicantJobs: _applicantslice.getApplicantJobsSlice.reducer,
  DeleteApplicantJobs: _applicantslice.deleteApplicantJobsSlice.reducer,
  GetMatchAssociatedJobs: _applicantslice.getMatchAssociatedJobsSlice.reducer,
  DeleteAssociatedjobs: _applicantslice.deleteAssociatedjobsSlice.reducer,
  AddAssociatedjobs: _applicantslice.addAssociatedjobsSlice.reducer,
  GetDocuments: _applicantslice.getDocumentsSlice.reducer,
  DeleteDocuments: _applicantslice.deleteDocumentsSlice.reducer,
  Downloaddocument: _applicantslice.downloaddocumentSlice.reducer,
  AddApplicantWithAssocated:
    _applicantslice.addApplicantWithAssocatedSlice.reducer,
  UploadDocuments: _applicantslice.uploadDocumentsSlice.reducer,
  ListNotes: _applicantslice.listNotesSlice.reducer,
  AddApplicantNotes: _applicantslice.addNotesSlice.reducer,
  EditApplicantNotes: _applicantslice.editNotesSlice.reducer,
  GetListApplicants: _applicantslice.getListApplicantsSlice.reducer,
  DeleteApplicants: _applicantslice.deleteApplicantsSlice.reducer,
  SearchApplicantsWithoutPaging:
    _applicantslice.searchApplicantsWithoutPagingSlice.reducer,
  SearchApplicantsWithPaging:
    _applicantslice.searchApplicantsWithPagingSlice.reducer,
  GetApplicantsComments: _applicantslice.getApplicantsCommentsSlice.reducer,
  GetBarChartData: _applicantslice.getBarChartDataSlice.reducer,
  GetPieChartData: _applicantslice.getPieChartDataSlice.reducer,
  GetRequirementAssigned: _applicantslice.getRequirementAssignedSlice.reducer,
  GetResumeCount: _applicantslice.getResumeCountSlice.reducer,
  BulkUploadResume: _applicantslice.BulkUploadResumeSlice.reducer,
  GetGraphOfStatus: _applicantslice.getGraphOfStatusSlice.reducer,
  GetGraphByClient: _applicantslice.getGraphByClientSlice.reducer,
  GetResumeCountByStatus: _applicantslice.getResumeCountByStatusSlice.reducer,
  TotalUploadedResumes: _applicantslice.getTotalUploadedResumesSlice.reducer,
  CountriesListByValue: _applicantslice.getCountriesListByValueSlice.reducer,
  SetSelectedJobDetails: _applicantslice.setSelectedJobDetailsSlice.reducer,
  TotalRecruiter: _applicantslice.getTotalRecruiterSlice.reducer,
  DeliveryOutcomeByClients:
    _applicantslice.getDeliveryOutcomeByClientsSlice.reducer,
  CandidateListByStatus: _applicantslice.getCandidateListByStatusSlice.reducer,
  JobStatusByClient: _applicantslice.getJobStatusByClientSlice.reducer,

  //clients service calls
  FilterClients: _clientslice.filterClientsSlice.reducer,
  GetClients: _clientslice.getClientsSlice.reducer,
  AddClients: _clientslice.addClientsSlice.reducer,
  EditClients: _clientslice.editClientsSlice.reducer,
  GetClientswithPaging: _clientslice.getClientswithPagingSlice.reducer,
  GetClientsWithFields: _clientslice.getClientswithFieldsSlice.reducer,
  DeleteClients: _clientslice.deleteClientsSlice.reducer,
  FilterClientsWithPaging: _clientslice.filterClientsWithPagingSlice.reducer,
  GetClientsComments: _clientslice.getClientsCommentsSlice.reducer,
  AddHiringManagers: _clientslice.addHiringmanagersSlice.reducer,
  GetHiringManagers: _clientslice.getHiringmanagersSlice.reducer,
  EditHiringmanagers: _clientslice.editHiringmanagersSlice.reducer,
  DeleteHiringmanagers: _clientslice.deleteHiringmanagersSlice.reducer,
  AddEndClients: _clientslice.addEndClientsSlice.reducer,
  GetEndClients: _clientslice.getEndClientsSlice.reducer,
  EditEndClients: _clientslice.editEndClientsSlice.reducer,
  DeleteEndClients: _clientslice.deleteEndClientsSlice.reducer,
  GetClientJobs: _clientslice.getClientJobsSlice.reducer,

  //User Manager Service Calls
  UserManager: _userslice.userManagerSlice.reducer,
  GetCustDetails: _userslice.getCustDetailsSlice.reducer,
  LoginPage: _userslice.loginPageSlice.reducer,
  CustomFields: _userslice.customFieldsSlice.reducer,
  GetEmailTemplates: _userslice.getEmailTemplatesSlice.reducer,
  GetEmailTemplatebyId: _userslice.getEmailTemplatebyIdSlice.reducer,
  SendEmail: _userslice.SendEmailSlice.reducer,
  BulkEmail: _userslice.BulkEmailSlice.reducer,
  ClientBulkEmail: _userslice.ClientBulkEmailSlice.reducer,
  DashboardConfig: _userslice.dashboardConfigSlice.reducer,
  GetSmsTemplates: _userslice.getSmsTemplatesSlice.reducer,
  GetSmsTemplatebyId: _userslice.getSmsTemplatebyIdSlice.reducer,
  GetCustomMessages: _userslice.getCustomMessagesSlice.reducer,
  GetAccessToken: _userslice.getAccessTokenSlice.reducer,
  UpdateUserDetails: _userslice.updateUserDetailsSlice.reducer,
  UnsubscribeDetails: _userslice.unsubscribeDetailsSlice.reducer,
  // billing
  GetInvoices: _billingslice.getInvoicesSlice.reducer,

  GetProjects: _Projectslice.getProjectsSlice.reducer,
  GetProjectsById: _Projectslice.getProjectsByIdSlice.reducer,
  GetProjectJobById: _Projectslice.getProjectJobByIdSlice.reducer,
  AddProjects: _Projectslice.addProjectsSlice.reducer,
  EditProjects: _Projectslice.editProjectsSlice.reducer,
  GetProjectsComments: _Projectslice.getProjectsCommentsSlice.reducer,
  GetAccessibleTo: _Projectslice.getAccessibleToSlice.reducer,
  GetProjectApplicants: _Projectslice.getProjectApplicantsSlice.reducer,
  AddAssociateProjectApplicants:
    _Projectslice.addAssociateProjectApplicantsSlice.reducer,
  DeleteProjectApplicants: _Projectslice.deleteProjectApplicantsSlice.reducer,
  DeleteProjectJobs: _Projectslice.deleteProjectJobsSlice.reducer,
  UpdateProjectJobStatus: _Projectslice.updateProjectJobStatusSlice.reducer,
  GetProjectJobs: _Projectslice.getProjectJobsSlice.reducer,
  AddAssociateProjectJobs: _Projectslice.addAssociateProjectJobsSlice.reducer,
  GetProjectsByApplicantId: _Projectslice.getProjectsByApplicantIdSlice.reducer,
  GetProjectsByJobPostingId: _Projectslice.getProjectsByJobPostingIdSlice.reducer,
  // Cloud Sourcing Service Calls
  GetQuestionsAnswers: _cloudslice.getQuestionsAnswersSlice.reducer,
  theme: themeReducer,

  // Custom Reports Service Calls
  CreateCustomReport: _customreportsslice.createCustomReportSlice.reducer,
  GetCustomReports: _customreportsslice.getCustomReportsSlice.reducer,
  DeleteCustomReport: _customreportsslice.deleteCustomReportSlice.reducer,
});

const RESET_STORE = "RESET_STORE";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "GetCountries",
    "GetCustDetails",
    "Listjobpostings",
    "SetSelectedJobDetails",
    "SeletedJobCode",
    "SeletedApplicantIds",
    "CustomFields",
    "Highlight",
    "GetListSegments",
    "GetAccessToken",
    "Auth",
    "SelectedApplicant",
    "SelectedJobPosting"
  ], // It will persist the data of declared reducers
};

const rootReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    state = undefined; // Reset state to undefined to reset the entire store
  }
  return appReducer(state, action);
};
// Apply persist reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

// Persistor for redux-persist
export const persistor = persistStore(store);

export const resetStore = () => ({ type: RESET_STORE });
